import { CardElement, PlayStyle } from "../types/battle"

export const STARTER_ELEMENTS = [
  "FIRE",
  "WATER",
  "EARTH",
  "LIGHTNING",
  "WIND",
  "ICE",
] as const

export const STARTER_STYLES = ["ATTACK", "DEFENSE", "SPEED"] as const

export type StarterElement = (typeof STARTER_ELEMENTS)[number]
export type StarterStyle = (typeof STARTER_STYLES)[number]

export type StarterCardChoice = {
  element: StarterElement
  style: StarterStyle
}

/** 18 комбинаций для сетки выбора (6 стихий × 3 стиля) */
export const STARTER_CARD_OPTIONS: StarterCardChoice[] = STARTER_ELEMENTS.flatMap(
  (element) => STARTER_STYLES.map((style) => ({ element, style }))
)

export const STARTER_ELEMENT_LABELS: Record<StarterElement, string> = {
  FIRE: "Огонь",
  WATER: "Вода",
  EARTH: "Земля",
  LIGHTNING: "Молния",
  WIND: "Ветер",
  ICE: "Лёд",
}

export const STARTER_STYLE_LABELS: Record<StarterStyle, string> = {
  ATTACK: "Атака",
  DEFENSE: "Защита",
  SPEED: "Скорость",
}

/** Проверка, что enum из API совпадает с типами карты */
export function toGameCardChoice(
  choice: StarterCardChoice
): { element: CardElement; style: PlayStyle } {
  return { element: choice.element, style: choice.style }
}
